import React, {useState} from 'react'
import ReactDOM from "react-dom/client";
import {BrowserRouter as Router, Route, Routes} from 'react-router-dom'

import './style.css'
import Home from './views/home'
import NotFound from './views/not-found'
import {HelmetProvider} from "react-helmet-async";
import LegalNotice from "./views/legal-notice";
import PrivacyPolicy from "./views/privacy-policy";
import CaseStudyMobileApp from "./views/case-study-mobile-app";
import CalModal from "./components/CalModal/CalModal";
import CaseStudyCiCD from "./views/case-study-ci-cd";
import CaseStudyAutomotive from "./views/case-study-micro-service-architecture";

const App = () => {
    const [isCalOpen, setIsCalOpen] = useState(false);

    const showCalModal = () => {
        setIsCalOpen(true);
        document.getElementsByTagName('body')[0].classList.add('stopScroll');
    }
    const hideCalModal = () => {
        setIsCalOpen(false);
        document.getElementsByTagName('body')[0].classList.remove('stopScroll');
    }
    return (
        <>
            <Router>
                <Routes>
                    <Route path="/" element={<Home showCalModal={showCalModal} hideCalModal={hideCalModal}/>}/>
                    <Route path="/legal" element={<LegalNotice/>}/>
                    <Route path="privacy" element={<PrivacyPolicy/>}/>
                    <Route path="case-studies/mobile-application"
                           element={<CaseStudyMobileApp showCalModal={showCalModal}/>}/>
                    <Route path="case-studies/ci-cd"
                           element={<CaseStudyCiCD showCalModal={showCalModal}/>}/>
                    <Route path="case-studies/micro-service-architecture"
                           element={<CaseStudyAutomotive showCalModal={showCalModal}/>}/>
                    <Route path="case-studies/cloud-hosting"
                           element={<CaseStudyMobileApp showCalModal={showCalModal}/>}/>

                    <Route path="*" element={<NotFound/>}/> {/* Handles 404s */}
                </Routes>
            </Router>
            <CalModal isOpen={isCalOpen} hideCalModal={hideCalModal}></CalModal>
        </>
    )
}

const root = ReactDOM.createRoot(document.getElementById("app"));
root.render(
    <React.StrictMode>
        <HelmetProvider>
            <App/>
        </HelmetProvider>
    </React.StrictMode>
);